module.exports = __webpack_public_path__ + "static/media/badge_level_2_1.33d92c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_2_1.png
// module id = 488
// module chunks = 0